import {
    post
} from './request'

// 廉政建设--廉政政策法规列表
export const getLianzhengzhengcefaguiPage = data => post('/index/lz_list', data)
// 廉政建设--文章详情
export const getLianzhengzhengcefaguiOne = data => post('/index/lz_detail', data)
//  举报投诉
export const getTousujubao = data => post('/index/lz_jb', data)